import { RecommendTargetDataWithLabel } from './types';

export function flattenRecommendTargetData(recommendData: RecommendTargetDataWithLabel) {
  return [
    ...(recommendData?.interest ?? []),
    ...(recommendData?.behavior?.video ?? []),
    ...(recommendData?.behavior?.creator ?? []),
    ...(recommendData?.interestKeywords ?? []),
  ];
}
